const getSelectedColor = () => {
  const productRoot = document.querySelector('.product_template_new');
  if (!productRoot) return '';

  const checkedInput = productRoot.querySelector(
    'input.single-option-selector__radio:checked'
  );
  if (checkedInput?.value) return checkedInput.value;

  const activeWrapper = productRoot.querySelector('.options-color-wrapper.active');
  const optionItem = activeWrapper?.querySelector('.option-item[data-value]');
  return optionItem?.getAttribute('data-value') || '';
};

const parseVariantMatch = (str) => {
  const trimmed = (str || '').trim();
  if (!trimmed) return null;
  return trimmed.split(',').map((item) => item.trim()).filter(Boolean);
};

const updateBenefitVisibility = () => {
  const productRoot = document.querySelector('.product_template_new');
  if (!productRoot) return;

  const selectedColor = getSelectedColor();
  const wrappers = productRoot.querySelectorAll('[data-variant-match]');

  wrappers.forEach((wrapper) => {
    const allowedColors = parseVariantMatch(wrapper.getAttribute('data-variant-match'));

    if (allowedColors === null) {
      if (wrapper.classList.contains('is-variant-hidden')) {
        wrapper.classList.remove('is-variant-hidden');
      }
      return;
    }

    const isVisible = allowedColors.includes(selectedColor);
    const shouldHide = !isVisible;
    if (wrapper.classList.contains('is-variant-hidden') === shouldHide) return;
    wrapper.classList.toggle('is-variant-hidden', shouldHide);
  });
};

const initBenefitVariantVisibility = () => {
  const productRoot = document.querySelector('.product_template_new');
  if (!productRoot) return;

  updateBenefitVisibility();

  productRoot.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (!target.closest('.options-color-wrapper')) return;

    window.setTimeout(() => {
      updateBenefitVisibility();
    }, 0);
  });

  productRoot.addEventListener('change', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (!target.matches('input.single-option-selector__radio')) return;

    updateBenefitVisibility();
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBenefitVariantVisibility);
} else {
  initBenefitVariantVisibility();
}
